import { Survey } from "@/types/surveys";
import { createApi, fakeBaseQuery, SkipToken } from "@reduxjs/toolkit/query/react";
import { collection, doc, getDoc, getDocs, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { RootState } from "@/store/store";

export const surveysApi = createApi({
  reducerPath: "surveys",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Survey"],
  endpoints: (builder) => ({
    fetchSurveys: builder.query({
      queryFn: async (organizationId: string) => {
        try {
          const collectionRef = collection(db, `organizations/${organizationId}/surveys`);

          const response = await getDocs(collectionRef).then((querySnapshot) => {
            return querySnapshot.docs.reduce((acc, doc: any) => {
              return [...acc, { ...doc.data(), id: doc.id }];
            }, [] as Survey[]);
          });

          return { data: response };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Survey"],
    }),
    fetchSurvey: builder.query({
      queryFn: async ({
        organizationId,
        surveyId,
      }: {
        organizationId: string | SkipToken;
        surveyId: string | SkipToken;
      }) => {
        try {
          if (typeof organizationId !== "string" || typeof surveyId !== "string") return { data: undefined };

          const surveyRef = doc(db, `organizations/${organizationId}/surveys/${surveyId}`);
          const surveySnapshot = await getDoc(surveyRef);

          return {
            data: {
              id: surveySnapshot.id,
              ...surveySnapshot.data(),
              // questions: questions ?? [],
            } as Survey,
          };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Survey"],
    }),
    updateSurvey: builder.mutation({
      queryFn: async (
        { organizationId, surveyId, payload }: { organizationId: string; surveyId: string; payload: Survey },
        { getState }
      ) => {
        try {
          const { auth } = getState() as RootState;

          if (!auth?.user?.uid) {
            return { data: undefined };
          }

          const draft: Survey = {
            ...payload,
            lastUpdatedBy: auth.user.uid,
            lastUpdatedAt: serverTimestamp(),
          };

          const collectionRef = doc(db, `organizations/${organizationId}/surveys/${surveyId}`);
          const response = await updateDoc(collectionRef, draft);
          return { data: response };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ["Survey"],
    }),

    // addFaq: builder.mutation({
    //   queryFn: async ({ organizationId, payload }: { organizationId: string; payload: NewFaq }, { getState }) => {
    //     try {
    //       const { auth } = getState() as RootState;

    //       if (!auth?.user?.uid) {
    //         return { data: undefined };
    //       }

    //       const draft: NewFaq = {
    //         ...payload,
    //         createdBy: auth.user.uid,
    //         createdAt: serverTimestamp(),
    //       };

    //       const collectionRef = collection(db, `organizations/${organizationId}/faqs`);
    //       const response = await addDoc(collectionRef, draft);
    //       return { data: response };
    //     } catch (error) {
    //       return { error };
    //     }
    //   },
    //   invalidatesTags: ["Faq"],
    // }),

    // deleteFaq: builder.mutation({
    //   queryFn: async ({ organizationId, faqId }: { organizationId: string; faqId: string }) => {
    //     try {
    //       const collectionRef = doc(db, `organizations/${organizationId}/faqs/${faqId}`);
    //       const response = await deleteDoc(collectionRef);
    //       return { data: response };
    //     } catch (error) {
    //       return { error };
    //     }
    //   },
    //   invalidatesTags: ["Faq"],
    // }),
  }),
});

export const { useFetchSurveysQuery, useFetchSurveyQuery, useUpdateSurveyMutation } = surveysApi;
export default surveysApi;

// , useAddFaqMutation, useDeleteFaqMutation, useUpdateFaqMutation
